import { useState } from "react"
import { Award, ChevronRight, ChevronLeft } from "lucide-react"

const awardLogos = [
  { src: "/media/awards/good-design-award-1.jpg", alt: "Good Design Award – Best in Class", bg: "bg-white", href: "https://good-design.org/projects/solid-waste-clog-resistant-smart-drain/" },
  { src: "/media/awards/wipo-global-awards.png", alt: "WIPO Global Awards", bg: "bg-white/[.08]", href: "https://www.wipo.int/en/web/awards/global/2025" },
  { src: "/media/awards/good-design-award-2.jpg", alt: "Good Design Award – Best in Class", bg: "bg-white", href: "https://good-design.org/projects/solid-waste-clog-resistant-smart-drain/" },
]

export function AwardsBanner() {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div
      className={`awards-banner fixed right-0 top-1/2 z-50 hidden -translate-y-1/2 transition-transform duration-500 ease-out lg:flex ${collapsed ? "translate-x-[calc(100%-2rem)]" : "translate-x-0"
        }`}
    >
      {/* Toggle button */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="flex h-10 w-8 items-center justify-center self-center rounded-l-xl border border-r-0 border-white/10 bg-[#0a2a2f]/90 text-emerald-300/80 backdrop-blur-xl transition-colors hover:bg-[#0a2a2f] hover:text-emerald-200"
        aria-label={collapsed ? "Show awards" : "Hide awards"}
      >
        {collapsed ? <ChevronLeft className="size-4" /> : <ChevronRight className="size-4" />}
      </button>

      {/* Banner body */}
      <div className="flex flex-col items-center gap-3 rounded-l-2xl border border-r-0 border-white/10 bg-[#0a2a2f]/90 px-3 py-5 shadow-2xl shadow-black/40 backdrop-blur-xl">
        <Award className="size-4 text-emerald-400" />
        <div className="text-[9px] font-bold uppercase tracking-[.22em] text-emerald-300/70">
          Awards
        </div>

        <div className="flex flex-col gap-2.5">
          {awardLogos.map((logo, i) => (
            <a
              key={i}
              href={logo.href}
              target="_blank"
              rel="noreferrer"
              className={`group relative block overflow-hidden rounded-xl ${logo.bg} p-2 shadow-lg shadow-black/10 transition-all duration-300 hover:scale-110 hover:shadow-emerald-500/20`}
              style={{ animationDelay: `${i * 150}ms` }}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-auto w-16 object-contain transition-transform duration-300 group-hover:brightness-110"
              />
              {/* Subtle shine effect on hover */}
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
            </a>
          ))}
        </div>

        <div className="mt-1 h-px w-full bg-gradient-to-r from-transparent via-emerald-400/30 to-transparent" />
        <div className="text-[8px] font-semibold uppercase tracking-[.15em] text-white/30">
          Verified
        </div>
      </div>
    </div>
  )
}
